import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    wrapper: "flex flex-col"
  },
  variants: {}
}), r = e({
  slots: {
    wrapper: "flex flex-col gap-2 lg:gap-3 items-center w-full",
    row: "flex justify-between w-full group/cart-row",
    label: "font-primary text-heading-2xs group-last/cart-row:text-heading-xs",
    value: "font-secondary text-heading-2xs group-last/cart-row:text-heading-xs"
  },
  variants: {
    withBackground: {
      true: {
        wrapper: "flex flex-col gap-4 items-center bg-white max-w-2xl w-full mx-auto p-4 lg:p-8 rounded-lg overflow-x-hidden"
      },
      false: {
        wrapper: ""
      }
    }
  }
}), a = e({
  slots: {
    wrapper: "flex flex-col items-center w-full"
  },
  variants: {}
}), o = e({
  slots: {
    base: "",
    trigger: "text-label-md",
    inputWrapper: "flex gap-2"
  },
  variants: {}
}), p = e({
  slots: {
    base: "",
    item: "",
    name: "",
    code: "",
    deleteButton: "",
    discount: ""
  },
  variants: {}
}), s = e({
  slots: {
    wrapper: "flex flex-col gap-4",
    header: "flex text-left w-full sticky top-0 pt-4 lg:pt-8 pb-3 lg:pb-6 left-0 z-10 bg-white/50 backdrop-blur-sm",
    cartWrapper: "flex flex-col items-center bg-white max-w-2xl w-full mx-auto px-4 pb-4 lg:px-8 lg:pb-8 pt-0 lg:pt-0 rounded-lg overflow-x-hidden overflow-y-scroll max-h-[50vh]"
  },
  variants: {
    heading: {
      hide: {
        header: "hidden"
      }
    },
    sticky: {
      true: {
        wrapper: "sticky top-6"
      }
    }
  }
});
export {
  a as cartItemsStyling,
  s as cartSummaryBirchStyling,
  l as cartSummaryStyling,
  r as cartTotalsStyling,
  o as voucherInputBlueprint,
  p as voucherListBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
